/**
 * AMS Top Bar - Minimal header for sidebar layout
 * Contains tenant selector and mobile sidebar toggle
 */
import { TenantSelector } from "@/global/components/auth/TenantSelector";
import { SidebarTrigger } from "@/components/ui/sidebar";

export function TopBar() {
  return (
    <header className="border-b border-r-0 border-white/10 bg-white/5 backdrop-blur-2xl fixed top-0 left-0 right-0 z-50">
      {/* iOS Safe Area Extension - Frosted glass continuing into notch */}
      <div className="absolute top-0 left-0 right-0 h-[env(safe-area-inset-top)] bg-white/5 backdrop-blur-2xl -translate-y-full" />

      <div
        className="flex h-[63px] items-center justify-center px-4"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        {/* Mobile sidebar toggle - only visible on mobile */}
        <SidebarTrigger className="md:hidden absolute left-4 h-[62px] w-[62px]" />
        
        <TenantSelector />
      </div>
    </header>
  );
}
